export default class Range {
  upTo = 0;
  price = 0;
  minOrder = 0;
  freeFee = false;
  old_price = "0";
  minDelivery = null;
  maxDelivery = null;

  constructor(
    upTo = 0,
    price = 0,
    minOrder = 0,
    freeFee = false,
    old_price = "0",
    minDelivery = 0,
    maxDelivery = 0
  ) {
    this.upTo = upTo;
    this.price = price;
    this.minOrder = minOrder;
    this.freeFee = freeFee;
    this.old_price = old_price;
    this.minDelivery = minDelivery;
    this.maxDelivery = maxDelivery;
  }
}
